import { NavLink, useNavigate } from "react-router-dom";
import { bannerBlog, blog } from "../../../utilities/blogData";
import { useEffect } from "react";
import EndingBanner from "../../../components/endingBanner";
import { motion } from "framer-motion";
import DefaultPadding from "../../../utilities/constants";
import styles from "../../../style/style.module.css";

const Blogs = () => {
  useEffect(() => {
    document.title = "Blogs";
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  }, []);

  const breakPoint = 6;
  const firstElements = blog.slice(1, breakPoint);
  const otherEle = blog.slice(breakPoint, blog.length);

  const navigate = useNavigate();

  const padding = new DefaultPadding();
  const defaultPaddingX = padding.getDefaultPaddingX();
  const defaultPaddingY = padding.getDefaultPaddingY();

  return (
    <main>
      <section
        className={`${defaultPaddingX} mt-[95.2px] box-border flex flex-col items-center justify-center gap-5 bg-visBlue ${defaultPaddingY} text-white`}
      >
        <h1 className="text-[52px] leading-[52px]">Our Blogs</h1>
        <p className="px-[1vw] text-center leading-[31px] md:px-[20vw] lg:text-[20px]">
          Discover valuable insights and in-depth articles on a range of crucial
          topics including SoS Emergency Calls Testing, Network Benchmarking,
          and comprehensive Software Testing and Automation Testing.
          Additionally, explore information on Field Performance Testing, Device
          Testing, Fiber Optics Deployments, Tuner and Media Testing, HMI
          Testing, API Testing, and more.
        </p>
        <motion.div
          whileHover={{
            scale: 1.05,
            cursor: "pointer",
            transition: { type: "spring", stiffness: 150, duration: 0.1 },
          }}
          onClick={() => {
            navigate(`/blogs/detail/${bannerBlog.uuid}`);
          }}
          className="grid w-full grid-cols-12 overflow-hidden rounded-sm"
        >
          <div className="col-span-12 h-full md:col-span-6">
            <img
              className="aspect-video h-full w-full object-cover"
              src={bannerBlog.image}
              alt=""
            />
          </div>
          <div className="col-span-12 bg-white md:col-span-6">
            <div className="flex h-full flex-col justify-center gap-3 px-10 py-5">
              <p className="text-black">{bannerBlog.date}</p>
              <p className="w-fit rounded-full bg-visOrange px-3 py-1 text-sm font-semibold">
                {bannerBlog.title}
              </p>
              <h1 className="text-3xl font-semibold text-visBlue">
                {bannerBlog.heading}
              </h1>
              <p className="text-black">{bannerBlog.discription}</p>
              <button className="w-fit text-start font-light text-visOrange">
                Read More
              </button>
            </div>
          </div>
        </motion.div>
      </section>
      <section className={`${defaultPaddingX} ${defaultPaddingY} bg-white`}>
        <div className="my-10 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {firstElements.map((item, index) => {
            return (
              <motion.div
                key={index}
                whileHover={{
                  scale: 1.05,
                  cursor: "pointer",
                  transition: { type: "spring", stiffness: 150, duration: 0.1 },
                }}
                onClick={() => {
                  navigate(`/blogs/detail/${item.uuid}`);
                }}
                className="col-span-1 overflow-hidden rounded-sm shadow-md"
              >
                <div className={`relative`}>
                  <img
                    className={`aspect-video w-full`}
                    src={item.image}
                    alt=""
                  />
                  <div
                    className={`${styles.blogDetailBannerGradient} absolute bottom-0 space-y-3 px-5 py-3 text-white`}
                  >
                    <p>{item.date}</p>
                    <p className="w-fit rounded-full bg-visOrange px-3 py-1 text-sm font-semibold text-white">
                      {item.title}
                    </p>
                    <p className="text-xl font-semibold text-white">
                      {item.heading}
                    </p>
                  </div>
                </div>

                <div className="space-y-3 px-5 py-3">
                  <p>{item.discription}</p>
                  <NavLink className="block w-fit rounded-sm bg-visOrange px-5 py-2 font-semibold text-white">
                    Read More
                  </NavLink>
                </div>
              </motion.div>
            );
          })}
          <motion.div
            whileHover={{
              scale: 1.05,
              cursor: "pointer",
              transition: { type: "spring", stiffness: 150, duration: 0.1 },
            }}
            className="col-span-1 flex flex-col items-center justify-center gap-5 overflow-hidden rounded-sm bg-visBlue p-5 text-center text-white"
          >
            <h2 className="text-2xl font-bold">
              Want to Discuss Your Project!
            </h2>
            <p className="">
              Contact us to discuss your Project and requirements with our
              experts.
            </p>

            <NavLink
              className="w-fit rounded-sm bg-visOrange px-10 py-3 text-sm font-bold text-white lg:text-[16px] lg:leading-[26px]"
              to="/contactus"
            >
              Contact Us Now
            </NavLink>
          </motion.div>
          {otherEle.map((item, index) => {
            return (
              <motion.div
                key={index}
                whileHover={{
                  scale: 1.05,
                  cursor: "pointer",
                  transition: { type: "spring", stiffness: 150, duration: 0.1 },
                }}
                onClick={() => {
                  navigate("/blogs/detail");
                }}
                className="col-span-1 overflow-hidden rounded-sm shadow-md"
              >
                <div className="relative">
                  <img
                    className="aspect-video w-full"
                    src={item.image}
                    alt=""
                  />
                  <div
                    className={`${styles.blogDetailBannerGradient} absolute bottom-0 space-y-3 px-5 py-3 text-white`}
                  >
                    <p>{item.date}</p>
                    <p className="w-fit rounded-full bg-visOrange px-3 py-1 text-sm font-semibold text-white">
                      {item.title}
                    </p>
                    <p className="text-xl font-semibold text-white">
                      {item.heading}
                    </p>
                  </div>
                </div>

                <div className="space-y-3 px-5 py-3">
                  <p>{item.discription}</p>
                  <NavLink className="block w-fit rounded-sm bg-visOrange px-5 py-2 font-semibold text-white">
                    Read More
                  </NavLink>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>
      <EndingBanner buttonText="Contact Now" />
    </main>
  );
};

export default Blogs;
